import { render, staticRenderFns } from "./ReleaseDetailOutlets.vue?vue&type=template&id=42df1bfc&scoped=true&"
import script from "./ReleaseDetailOutlets.vue?vue&type=script&lang=js&"
export * from "./ReleaseDetailOutlets.vue?vue&type=script&lang=js&"
import style0 from "./ReleaseDetailOutlets.vue?vue&type=style&index=0&id=42df1bfc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42df1bfc",
  null
  
)

export default component.exports